<div class="input">
    <i class="input__prefix">
        <ng-content select=".input-prefix"></ng-content>
    </i>

        <input #inputElement
               tabindex="0"
               name="input"
               type="text"
               (blur)="onBlur()"
               [ngModel]="value()"
               (ngModelChange)="onInputValue($event)"
               [disabled]="isDisabled()"
               [mask]="maskValue()"
        >

    <i class="input__icon">
        <ng-content select=".input-icon"></ng-content>
    </i>
    @if (error()) {
        <div class="input__error">{{ error() }}</div>
    }
</div>
